import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { ImCross } from 'react-icons/im'
import { toast } from 'react-toastify'
import { WebApiCalls } from '../../../webApiCalls/WebApiCalls'
import { useAuth } from '../../../hooks/useAuth'
const EditCommuterModal = (props) => {
    const {getToken}=useAuth();
    const { data, handleClose, show, getAllData } = props
    const [id, setId] = useState()
    const [name, setName] = useState()
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()
    const [gender, setGender] = useState()
    const [d_o_b, setD_o_b] = useState()
    const [status, setStatus] = useState()

    useEffect(() => {
        setId(data?._id)
        setName(data?.name)
        setEmail(data?.email)
        setPhone(data?.phone_no)
        setGender(data?.gender)
        setD_o_b(data?.dob)
        setStatus(data?.status)

    }, [data])


    const handleSubmit = async (e) => {
        e.preventDefault()
        handleClose()
        if (!name) {
            toast.error('Name is empty', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            }
            )
            return;
        }
        else if (!email) {
            toast.error('Email is empty', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            }
            )
            return;
        }
        else if (!phone) {
            toast.error('Phone number is empty', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            }
            )
            return;
        }
        else if (!d_o_b) {
            toast.error('Date of Birth is empty', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            }
            )
            return;
        }
        const token = getToken();
        if (token && id) {
            const obj = {
                name, email, gender, phone, status,
            }
            await new WebApiCalls().updateCommuter(JSON.parse(token), obj, id)
                .then(res => {
                    if (res?.code == 200) {
                        toast.success(res?.desc)
                        getAllData()
                    }
                    else {
                        toast.error("Oops...! Something went wrong")
                    }
                })
                .catch(err => {
                    console.log("Error here:    ", err);
                })
        }
    }

    return (
        <Modal
            size="lg"
            show={show}
            onHide={(e) => handleClose(e)}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
        >
            <Form onSubmit={(e) => handleSubmit(e)}>
                <Modal.Header className='px-0'>
                    <Modal.Title className='modal-title px-4' id="example-modal-sizes-title-lg">
                        Edit Commuter Detail
                    </Modal.Title>
                    <button className="modal-close-btn me-4 text-center" onClick={e => {
                        e.preventDefault()
                        handleClose()

                    }}>
                        <ImCross color='#fff' size={12} />
                    </button>
                </Modal.Header>
                <Modal.Body className='px-4 justify-content-center'>
                    <Row className="mx-2">

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Name</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={name} onChange={e => setName(e.target.value)}
                                    placeholder="Name here" required />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Email</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={email} onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email here" required
                                // oninvalid={(e)=>setCustomValidity(e)}
                                // oninput={(e)=>{setCustomValidity()}}
                                />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Phone Number</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" 
                                type="text"
                                value={phone} 
                                onChange={e => setPhone(e.target.value)}
                                placeholder="+2323232323" 
                                pattern='^\+\d{7,10}$'
                                required />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Gender</div>
                            <div className='mt-2'>
                                <select className='gender-selector' value={gender} onChange={e => setGender(e.target.value)}>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                                {/* <input className="edit-modal-input" type="text"
                                    value={gender} onChange={e => setGender(e.target.value)}
                                    defaultValue={data?.gender} placeholder="Gender" required /> */}
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Date of Birth</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={d_o_b} onChange={e => setD_o_b(e.target.value)}
                                    defaultValue={data?.dob} placeholder="Date of Birth" required />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Status</div>
                            <div className='mt-2'>
                                <select className='status-selector' value={status} onChange={(e) => {
                                    setStatus(e.target.value)

                                }}>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>

                                {/* <input className="edit-modal-input" type="text"
                                    value={status} onChange={e => setStatus(e.target.value)}
                                    defaultValue={data?.dob} placeholder="Date of Birth" required /> */}
                            </div>
                        </Col>

                        {/* <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>No. Of Trips</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={no_of_trips}
                                    defaultValue={data?.no_of_trips} placeholder="No. of Trips" />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Total Traveled Distance</div>
                            <div className='modal-small-heading'>Total Traveled Distance</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={totalDistanceTraveled}
                                    defaultValue={data?.total_traveled_distance} placeholder="Total Traveled Distance" />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>GHG Emission Saved</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={ghgEmissionSaved}
                                    defaultValue={data?.ghg_emission} placeholder="GHG Emission Saved"
                                />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Earned Points</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={earnedPoints} onChange={e => setEarnedPoints(e.target.value)}
                                    defaultValue={data?.reward_points} placeholder="Earned Points" required
                                />
                            </div>
                        </Col> */}
                    </Row>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-center'>
                    <Button type="submit" className='default-btn save-btn'>SAVE</Button>
                </Modal.Footer>
            </Form>
        </Modal >
    )
}
export default EditCommuterModal